import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { userForgetPassword } from "../../slices/auth/forgetpwd/thunk";
import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { userChangeForgottenPassword } from "slices/auth/changeforgetpwd/thunk";

import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Input,
  Row,
  Alert,
} from "reactstrap";


const selectProperties = createSelector(
  (state: any) => state.ChangeForgotPassword,
  (changeForgotPassword) => ({
    changeForgetError: changeForgotPassword.changeForgetError,
    changeForgetSuccessMsg: changeForgotPassword.changeForgetSuccessMsg,
  })
);

const ChangeForgottenPassword = () => {
  //meta title
  document.title = "Change Password | WeReload";
  
  const dispatch = useDispatch<any>();
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;

  const { changeForgetError, changeForgetSuccessMsg } = useSelector(selectProperties);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      code: "",
      newPassword: "",
      confirmNewPassword: "",
    },
    validationSchema: Yup.object({
      code: Yup.string()
        .matches(/^\d{6}$/, "Code must be exactly 6 digits")
        .required("Please Enter Verification Code"),
      newPassword: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Please Enter Your New Password"),
      confirmNewPassword: Yup.string()
        .oneOf([Yup.ref('newPassword')], 'Passwords must match')
        .required("Please Confirm Your New Password"),
    }),
    onSubmit: (values) => {
      dispatch(userChangeForgottenPassword({
        code: values.code, 
        password: values.newPassword, 
        passwordConfirmation: values.confirmNewPassword
      }, {
        router: {
          navigate
        }
      }));
    },
  });

  const handleResendCode = () => {
    dispatch(userForgetPassword({email, dontNavigate: true}, {
      router: {
        navigate
      }
    }));
  }


  return (
    <React.Fragment>


      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bxs-envelope h1 mb-0 text-primary"></i>
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <h4>Verify your email</h4>
                        <p className="mb-5">
                          Please enter the 6 digit code sent to{" "}
                          <span className="fw-semibold"> {email}</span>
                        </p>

                        <Form>
                          <Row>
                            <div className="mb-3">
                              <Label className="form-label">Verification Code</Label>
                              <Input
                                name="code"
                                className="form-control"
                                placeholder="Enter 6-digit verification code"
                                type="text"
                                maxLength={6}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.code || ""}
                                invalid={
                                  validation.touched.code &&
                                  validation.errors.code
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                          <Row>
                            <div className="mb-3">
                              <Label className="form-label">New Password</Label>
                              <Input
                                name="newPassword"
                                className="form-control"
                                placeholder="Enter New Password"
                                type="password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.newPassword || ""}
                                invalid={
                                  validation.touched.newPassword &&
                                  validation.errors.newPassword
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                          <Row>
                            <div className="mb-3">
                              <Label className="form-label">Confirm New Password</Label>
                              <Input
                                name="confirmNewPassword"
                                className="form-control"
                                placeholder="Enter Confirm New Password"
                                type="password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.confirmNewPassword || ""}
                                invalid={
                                  validation.touched.confirmNewPassword &&
                                  validation.errors.confirmNewPassword
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        </Form>

                        {changeForgetError ? (
                          <Alert color="danger" style={{ marginTop: "13px" }}>
                            {changeForgetError}
                          </Alert>
                        ) : null}
                        {changeForgetSuccessMsg ? (
                          <Alert color="success" style={{ marginTop: "13px" }}>
                            {changeForgetSuccessMsg}
                          </Alert>
                        ) : null}

                        <div className="mt-4">
                          <button
                            type="submit"
                            className="btn btn-success w-md"
                            disabled={validation.isSubmitting || changeForgetSuccessMsg}
                            onClick={() => validation.handleSubmit()}
                          >
                            Confirm
                          </button>

                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Didn't receive a code ?{" "}
                  <button
                    type="button"
                    className="btn btn-link fw-medium text-primary p-0"
                    onClick={handleResendCode}
                  >
                    Resend
                  </button>
                </p>
                <p>
                  © {new Date().getFullYear()} WeReload
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default ChangeForgottenPassword;
